import { useAuthContext } from "../auth/AuthProvider";

// ทำไว้เป็น alias เผื่ออนาคตอยากเพิ่ม logic เพิ่มเติมใน hook เดียว
export function useAuth() {
  return useAuthContext();
}